import { render } from "./purchase-order-modal.vue?vue&type=template&id=1d8623a0&scoped=true"
import script from "./purchase-order-modal.vue?vue&type=script&lang=js"
export * from "./purchase-order-modal.vue?vue&type=script&lang=js"

import "./purchase-order-modal.vue?vue&type=style&index=0&id=1d8623a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d8623a0"]])

export default __exports__